export enum Roles {
	Hedgehog = 'ACL-QWizard-HEDGEHOG',
	QWiz = 'ACL-QWizard-QWIZ',
	Admin = 'ACL-QWizard-ADMIN',
	User = 'ACL-QWizard-USER',
}

